import React from 'react';

export default function Mail({ value }) {
  return <a href={`mailto:${value}`}>{value}</a>
}